<template>
    <div>
        <div style="width: 90%">
            <div v-if="displayMetricsOwnerIfAdmin" style="text-align: center">
                Current Winery: {{ this.wineryName }}
            </div>
            <b-card bg-variant="light">
                <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Annual Update"
                              label-for="input-sm">

                    <b-form-textarea rows="6" id="text-annualUpdate" aria-describedby="password-help-block"
                                     v-model="annualUpdate"></b-form-textarea>

                </b-form-group>

                <div class="button-holder">
                    <b-button style="background-color: #1e7e34" class="submit-button" type="submit"
                              @click="submitAnnualUpdate" variant="primary">Submit
                    </b-button>

                    <b-button style="background-color: darkred" class="cancel-button" type="cancel" @click="cancel"
                              variant="primary">Cancel
                    </b-button>
                </div>
            </b-card>

            <div class="page-header" style="background-color: lightgray">
                <h2 style="padding-left: 30px; padding-top: 10px; padding-bottom: 10px">Updates</h2>
            </div>

            <b-table style="margin: 20px;" :items="annualUpdateList" :fields="updateFields" responsive=true
                     primary-key="_id">
            </b-table>

            <div class="page-header" style="background-color: lightgray">
                <h2 style="padding-left: 30px; padding-top: 10px; padding-bottom: 10px">Uploaded Files</h2>
            </div>
            <b-modal id="modal-1" title="Annual Update Submitted" effect="fade/zoom" hide-footer>
                <div>
                    <p class="my-4">{{ updateMessage }}</p>
                    <div slot="modal-footer" class="modal-footer">
                    </div>
                    <b-button type="button" class="btn btn-default mt-3" @click="dismissTheModal">Continue</b-button>
                </div>
            </b-modal>
        </div>
        <div class="container">
            <!--UPLOAD-->
            <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving" name="fileUpload">
                <div class="dropbox">
                    <input type="file" multiple :name="uploadFieldName" :disabled="isSaving"
                           @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                           accept="image/*" class="input-file">
                    <p v-if="isInitial">
                        Drag your file(s) here to begin<br> or click to browse
                    </p>
                    <p v-if="isSaving">
                        Uploading {{ fileCount }} files...
                    </p>
                </div>
            </form>
            <!--SUCCESS-->
            <div v-if="isSuccess">
                <h2>Uploaded {{ uploadedFiles.length }} file(s) successfully.</h2>
                <p>
                    <a href="javascript:void(0)" @click="reset()">Upload again</a>
                </p>
                <ul class="list-unstyled">
                    <li v-for="item in uploadedFiles">
                        <!--<img :src="item.url" class="img-responsive img-thumbnail" :alt="item.originalName">-->
                        File Name: {{ item.name }}
                    </li>
                </ul>
            </div>
            <!--FAILED-->
            <div v-if="isFailed">
                <h2>Uploaded failed.</h2>
                <p>
                    <a href="javascript:void(0)" @click="reset()">Try again</a>
                </p>
                <pre>{{ uploadError }}</pre>
            </div>
        </div>
        <b-table style="margin: 20px;" :items="archivedFiles" :fields="archivedFilesFields" responsive
                 primary-key="_id">
            <template v-slot:cell(id)="data">
                <b-button style="background-color: #1c7430" size="sm"
                          @click="downloadFile(data.item.id, data.item.fileName)">
                    Download
                </b-button>
            </template>
            <template v-slot:cell(delete)="data">
                <b-button style="background-color: darkred" size="sm"
                          @click="deleteFile(data.item.id, data.item.fileName)">
                    Delete File
                </b-button>
            </template>
        </b-table>
    </div>

</template>

<script>
import {uploadWithClient} from '../file-upload.service';
import Swal from "sweetalert2";

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;


export default {
  name: "AnnualUpdate",
  data() {
    return {
      darkMode: false,
      uploadedFiles: [],
                uploadError: null,
                currentStatus: null,
                uploadFieldName: 'actionPlan',
                annualUpdate: '',
                annualUpdateList: [],
                updateFields: [{
                    "key": 'updatedDate',
                    formatter: value => {
                        if (value === "" || value === null) {
                            return "Unknown";
                        }
                        let dateMillis = Date.parse(value);
                        let date = new Date(0);

                        date.setUTCMilliseconds(value);

                        return date.toLocaleDateString();
                    }
                },
                    {
                        "key": "updatedBy",
                        "label": "Updated By"
                    },
                    {
                        "key": "text",
                        "label": "Content"
                    }
                ],
                archivedFiles: [],
                archivedFilesFields: [
                    {
                        "key": "id",
                        "label": "Download"
                    },
                    {
                        "key": 'uploadDate',
                        formatter: value => {
                            if (value === "" || value === null) {
                                return "Unknown";
                            }
                            let dateMillis = Date.parse(value);
                            let date = new Date(0);

                            date.setUTCMilliseconds(value);

                            return date.toLocaleDateString();
                        }
                    },
                    {
                        "key": "fileName",
                        "label": "File Name"
                    },
                    {
                        "label": "Delete",
                        "key": "delete",
                        formatter: value => {
                            return value;
                        }
                    }],
                updateMessage: 'Annual Update Submission Successful',
                myGroupId: localStorage.getItem("adminImpersonationGroupId") || localStorage.getItem("groupId"),
                isAdmin: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('admin'),
                wineryName: ''
            }
        },
        beforeRouteEnter(to, from, next) {
            if (localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('THIRD_PARTY_CERTIFIER')) {
                next({name: "Questionnaire Admin", params: {}})
            } else {
                next()
            }

        },
        computed: {
          displayMetricsOwnerIfAdmin: function () {
            return this.isAdmin || this.isVineyardAdminMeth;
          },
          isVineyardAdminMeth: function () {
            let rolesList = localStorage.getItem("roles");
            return ((rolesList !== undefined) && (rolesList !== null)) && rolesList.includes("VINEYARD_ADMIN");
          },
          isInitial() {
            return this.currentStatus === STATUS_INITIAL;
          },
          isSaving() {
            return this.currentStatus === STATUS_SAVING;
          },
          isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
          },
          isFailed() {
                return this.currentStatus === STATUS_FAILED;
            }
        },
        mounted() {
            console.log("About To mount");
            this.loadAnnualUpdates();
            this.reset();
            this.getGroupInfo();
        },
        methods: {
            downloadFile: function (id, fileName) {
                this.$http.get('/survey/action-plan/download/' + id, {responseType: 'blob'})
                    .then((response) => {
                        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', fileName);
                        document.body.appendChild(fileLink);
                        fileLink.click();

                    });
            },
            deleteFile: function (id, fileName) {
                let self = this;
                Swal.fire({
                    title: 'Are You Sure?',
                    text: 'Do you really want to delete, ' + fileName + ', this cannot be undone?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                })
                    .then((result) => {
                        if (result.value) {
                            this.$http.delete('/survey/action-plan/' + id)
                                .then((response) => {
                                    let status = response.status;
                                    return status === 200;

                                }).then((result) => {
                                if (result) {
                                    Swal.fire(
                                        'Deleted!',
                                        'Your file has been deleted.',
                                        'success'
                                    )
                                } else {
                                    Swal.fire(
                                        'Error!',
                                        'There was an error deleting your file.',
                                        'error'
                                    )
                                }
                            })
                                .then(() => {
                                        self.loadUploadedFiles();
                                    }
                                );
                        }

                    });

            },
            reset() {
                // reset form to initial state
                this.currentStatus = STATUS_INITIAL;
                this.uploadedFiles = [];
                this.uploadError = null;
            },
            save(formData, group) {
                // upload data to the server
                this.currentStatus = STATUS_SAVING;
                let self = this;
                uploadWithClient(formData, group, this.$http)
                    //upload(formData, group)
                    .then(x => {
                        this.loadUploadedFiles();
                        self.uploadedFiles = [].concat(x);
                        self.currentStatus = STATUS_SUCCESS;
                    })
                    .catch(err => {
                        self.uploadError = err.response;
                        self.currentStatus = STATUS_FAILED;
                    });
            },
            filesChange(fieldName, fileList) {
                //let self = this;
                // handle file changes
                const formData = new FormData();

                if (!fileList.length) return;

                // append the files to FormData
                Array
                    .from(Array(fileList.length).keys())
                    .map(x => {
                        formData.append(fieldName, fileList[x], fileList[x].name);
                    });

                formData.forEach(function (value, key) {
                    console.log(key);
                    console.log(value);
                });
                // save it
                let group = localStorage.getItem("adminImpersonationGroupId") || localStorage.getItem("groupId");
                this.save(formData, group);
            },
            loadUploadedFiles: function () {
                this.$http.get("survey/action-plan/" + this.myGroupId)
                    .then(response => {
                        let self = this;
                        console.log(response.data);
                        self.archivedFiles = response.data;
                    });
            },
            loadAnnualUpdates: function () {
                this.$http.get("survey/annual-update/" + this.myGroupId)
                    .then(response => {
                        let self = this;
                        console.log(response.data);
                        self.annualUpdateList = response.data;
                    });
                this.loadUploadedFiles();
            },
            submitAnnualUpdate: function () {
                let self = this;

                if (!self.annualUpdate) {
                    this.displayPopUp("Update may NOT Be Blank, Please Enter Text.", "failure", 3000);
                    return;
                }

                this.$http.post("survey/annual-update", {
                        text: self.annualUpdate,
                        groupId: self.myGroupId,
                        updatedBy: localStorage.getItem("user")
                    },
                    {
                        headers: {
                            'content-type': 'application/json'
                        },
                    })
                    .then(result => {
                        if (result.status === 202) {
                            this.$bvModal.show("modal-1");
                            self.annualUpdate = "";
                        }
                    })
                    .catch(error => {
                        this.displayPopUp("Failed to save annual update. Error : " + error, "failure", 3000);
                    })
                    .then(respond => {
                        this.loadAnnualUpdates();
                    });


            },
            cancel: function () {
                this.$router.push("/my-account");
            },
            dismissTheModal: function () {
                this.newPassword = '';
                this.newPasswordConfirm = '';
                this.currentPassword = '';
                this.$bvModal.hide("modal-1");
                if (this.passwordUpdateStatus === true) {
                    this.$router.push("/my-account");
                }

            },
            displayPopUp(message, type, duration) {
                swal({
                    title: message,
                    type: type,
                    timer: duration
                });
            },
            getGroupInfo: function () {
                this.$http.get("/groups/name/" + this.myGroupId, {
                    headers: {
                        'content-type': 'application/json'
                    }
                }).then(response => {
                    console.log(response);
                    this.wineryName = response.data.name;
                }).catch(error => {
                    console.log("Error getting Data: " + error);
                });
            }
        }
    }
</script>

<style scoped>
    .cancel-button {
        margin-left: 10px;
        margin-top: 5px;
    }

    .submit-button {
        margin-left: 10px;
        margin-top: 5px;
    }

    .button-holder {
        horiz-align: center;
        display: flex; /*Requires vendor prefixes*/
        justify-content: center; /*Requires vendor prefixes*/
        align-items: center; /*Requires vendor prefixes*/
    }

    .dropbox {
        outline: 2px dashed grey; /* the dash box */
        outline-offset: -10px;
        background: lightcyan;
        color: dimgray;
        padding: 10px 10px;
        min-height: 200px; /* minimum height */
        position: relative;
        cursor: pointer;
    }

    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    .dropbox:hover {
        background: lightblue; /* when mouse over to the drop zone, change color */
    }

    .dropbox p {
        font-size: 1.2em;
        text-align: center;
        padding: 50px 0;
    }
</style>
